import * as api from './api';
import analytics from './analytics';

export default { api, analytics };
